import React from 'react';

class Erro404 extends React.Component {
 
    render() {
        return (<h1 className="text-center pt-4">Pagina não encontada</h1>);
    }
}

export default Erro404;